import React, { Component } from 'react';
import { getTokenData, getLabelAngleWithFontSize, referenceLine } from '../graphConstants';
import language from '../../../../../assets/languages/language';

import ChapterWiseGraph from './ChapterWiseGraph';
import { canvasjsConfig } from '../../../../../common/constant';
import { fetchCBTChapterWiseGraph } from '../../../services';

export default class MainGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      activeTabFlashcards: 1,
      scoreBoxSize: 5,
    };
  }
  componentDidMount() {
    const w = window.innerWidth;
    this.setState(getLabelAngleWithFontSize(w));

    const tokenData = getTokenData();
    this.setState(tokenData);

    const { id = 0, testId = 0, totalQuestions, timer = 0, isNegative } = this.props.params;

    const data = {
      ...tokenData,
      mock_id: parseInt(id, 10),
      test_id: parseInt(testId, 10),
      totalQuestion: parseInt(totalQuestions, 10),
      timer: parseInt(timer, 10),
      isNegative: isNegative,
    };
    this.getGraphData(data);
  }
  // get data for chaptervise graph
  getGraphData = data => {
    fetchCBTChapterWiseGraph(data).then(async res => {
      console.log('res', res);
      if (res.success === 'true' || res.success === true)
        if (res.graphData.length > 6) {
          this.setState({
            labelAngle: -90,
          });
        }
      const { totalQuestions } = this.props.params;
      this.setState({
        isLoading: false,
        totalQuestionsChapterwise: totalQuestions,
        graphData: res.graphData,
        averageoverAll: res.graphData,
      });
      this.formatData(res);
    });
  };

  //Format data as requirement
  formatData = res => {
    // console.log('res ------> ', res);
    const { graphData } = res;

    let initialValue = 0;
    // Reference line for 70%

    //20% line chaptervise graph
    let dataOfTwenty = {
      showInLegend: false,

      name: '20%',
      type: 'line',
      lineDashType: 'dash',
      color: '#39c089',
      dataPoints: [],
      markerType: 'none',
    };
    //80% line chaptervise graph
    let dataOfEighty = {
      showInLegend: false,
      name: '80%',
      type: 'line',
      lineDashType: 'dot',
      color: '#1d364b',
      dataPoints: [],
      markerType: 'none',
    };
    //Userscore line chaptervise graph
    let UserScore = {
      showInLegend: false,
      name: `${language.LC().GRAPHSCORE}`,
      type: 'line',
      color: '#1f8ceb',
      markerType: 'none',
      dataPoints: [],
      overlayBars: true,
    };

    let UserScoreBox2 = {
      showInLegend: false,
      // legendMarkerType: 'square',
      name: `${language.LC().GRAPHSCOREBOX}`,
      type: 'rangeColumn',
      color: '#cce7f5',
      dataPoints: [],
    };
    initialValue = -10;
    // console.log('graphData -------------> ', graphData);
    let graphDataLength = graphData && graphData.length ? graphData.length : 0;
    for (let k = 0; k < graphDataLength; k++) {
      const { scoreBoxSize } = this.state;
      console.log('graphData[k].dataOfCurrentUser', graphData[k].dataOfCurrentUser);
      UserScoreBox2.dataPoints.push({
        x: initialValue + 15,
        label: `${graphData[k].chapterDetails['esg_chapter.name']}`,
        y: [
          graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize,
          graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize,
        ],
      });
      let dataOfCurrentUserLineStart = {
        x: initialValue + 15 - 1.5,

        y: graphData[k].dataOfCurrentUser.Percentage,
      };
      let dataOfCurrentUserLineMid = {
        x: initialValue + 15 + 1.5,

        y: graphData[k].dataOfCurrentUser.Percentage,
      };
      let dataOfCurrentUserLineEnd = {
        x: initialValue + 15 + 1.5,
        y: null,
      };
      UserScore.dataPoints.push(
        dataOfCurrentUserLineStart,
        dataOfCurrentUserLineMid,
        dataOfCurrentUserLineEnd,
      );
      initialValue += 15;
    }
    initialValue = 0;
    for (let i = 0; i < graphDataLength; i++) {
      let dataOfTwentyPercentileUserlineStart = {
        x: initialValue,

        y: graphData[i].dataOfTwentyPercentileUser.Percentage,
      };
      let dataOfTwentyPercentileUserlineMid = {
        x: initialValue + 10,

        y: graphData[i].dataOfTwentyPercentileUser.Percentage,
      };
      let dataOfTwentyPercentileUserlineEnd = {
        x: initialValue + 10,

        y: null,
      };
      dataOfTwenty.dataPoints.push(
        dataOfTwentyPercentileUserlineStart,
        dataOfTwentyPercentileUserlineMid,
        dataOfTwentyPercentileUserlineEnd,
      );
      let dataOfEightyPercentileUserLineStart = {
        x: initialValue,

        y: graphData[i].dataOfEightyPercentileUser.Percentage,
      };
      let dataOfEightyPercentileUserLineMid = {
        x: initialValue + 10,

        y: graphData[i].dataOfEightyPercentileUser.Percentage,
      };
      let dataOfEightyPercentileUserLineEnd = {
        x: initialValue + 10,
        y: null,
      };
      dataOfEighty.dataPoints.push(
        dataOfEightyPercentileUserLineStart,
        dataOfEightyPercentileUserLineMid,
        dataOfEightyPercentileUserLineEnd,
      );

      initialValue += 15;
    }
    const data = [];
    console.log('UserScoreBox2', UserScoreBox2);
    data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, referenceLine);

    this.setState(
      {
        dataPoints: data,
      },
      () => {
        this.showGraph(); //Show chaptervise graph
      },
    );
  };

  // show graph chaptervise graph
  showGraph = () => {
    const { dataPoints } = this.state;

    const chart = new window.CanvasJS.Chart('chartContainer', {
      animationEnabled: true,
      axisY: canvasjsConfig.axisY,
      axisX: {
        ...canvasjsConfig.axisX,
        labelAngle: this.state.labelAngle,
        labelFontSize: this.state.labelFontSize,
      },

      toolTip: canvasjsConfig.toolTip,
      data: dataPoints,

      dataPointMaxWidth: 60,
      dataPointWidth: 60,
      dataPointMinWidth: 60,
      legend: {
        fontSize: 18,
      },
      interactivityEnabled: false,
    });

    chart.render();
  };

  flashcardTabToggle = tab => {
    const { activeTabFlashcards } = this.state;
    if (activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };

  render() {
    const { graphData, activeTabFlashcards } = this.state;
    return (
      <ChapterWiseGraph
        graphData={graphData}
        flashcardTabToggle={this.flashcardTabToggle}
        activeTabFlashcards={activeTabFlashcards}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ResultGraph/ChapterWiseGraph/index.jsx